import { render } from "./CartPage.vue?vue&type=template&id=12243bd0&ts=true"
import script from "./CartPage.vue?vue&type=script&lang=ts"
export * from "./CartPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__